import React from 'react';
import { FaFilePdf, FaExternalLinkAlt } from 'react-icons/fa';
import './Brochure.css';

const schedules = [
  {
    title: 'Program Schedule',
    description: 'Complete conference program and schedule',
    href: '/schedule.pdf'
  },
  {
    title: 'Technical Programme',
    description: 'Final technical programme details',
    href: '/Technical_Programme_Final.pdf'
  },
  {
    title: 'Poster Presentation Schedule',
    description: 'Poster presentation schedule with abstract IDs',
    href: '/Poster_Presentation_Schedule_and_Abstract%20ID.pdf'
  },
  {
    title: 'Oral Presentations Schedule',
    description: 'Oral presentations schedule with abstract IDs',
    href: '/Oral_Presentations_Schedule_and_Abstrat%20ID.pdf'
  },
  {
    title: 'Final Proceedings',
    description: 'Complete conference proceedings',
    href: '/Final_Proceedings.pdf'
  }
];

const Brochure = () => {
  return (
    <div className="brochure-page">
      <div className="brochure-page-header">
        <div className="brochure-container">
          <h1 className="brochure-page-title"><FaFilePdf /> Program Schedules</h1>
          <p className="brochure-page-subtitle">View all conference schedules and programmes</p>
        </div>
      </div>

      <div className="brochure-container">
        <div className="brochure-schedules-grid">
          {schedules.map((item, index) => (
            <div key={index} className="brochure-schedule-card">
              <div className="brochure-schedule-icon">
                <FaFilePdf />
              </div>
              <div className="brochure-schedule-info">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <a
                className="brochure-download-btn"
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaExternalLinkAlt className="download-icon" />
                Open PDF
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Brochure;
